import { render, staticRenderFns } from "./JobTitle.vue?vue&type=template&id=0963eea6&scoped=true"
import script from "./JobTitle.vue?vue&type=script&lang=ts"
export * from "./JobTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963eea6",
  null
  
)

export default component.exports